import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "@components/layout/Navbar";
import PatientForm from "@components/form/PatientForm";
import SuccessModal from "@components/common/SuccessModal";
import FailureModal from "@components/common/FailureModal";
import { upsertPatient } from "@services/patient";

export default function NewPatient() {
  const location = useLocation();
  const navigate = useNavigate();
  const patient = location.state?.patient || null;

  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (form) => {
    try {
      const result = await upsertPatient(form);
      if (result) {
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          navigate("/patient-profile", { state: result.data.patient });
        }, 3000);
      }
    } catch (error) {
      console.error("Patient save failed", error);
      setErrorMessage(error.message || "Something went wrong.");
      setShowFailure(true);
      setTimeout(() => setShowFailure(false), 4000);
    }
  };

  return (
    <div className="min-h-screen">
      <div className="sticky top-0 z-50">
        <Navbar showFieldSearch={false} />
      </div>
      <div className="mt-4 px-4">
        <PatientForm onSubmit={handleSubmit} patient={patient} />
      </div>
      <SuccessModal
        isOpen={showSuccess}
        title={"Patient created successfully!"}
        message={
          "You can now start filling out forms or view the patient’s profile."
        }
      />
      <FailureModal
        isOpen={showFailure}
        titleError={"Failed to create patient"}
        errorMessage={errorMessage}
      />
    </div>
  );
}
